import React, { useEffect, useState } from "react";
import { FaGem, FaRegClock } from "react-icons/fa";

const WelcomeCard = () => {
  const [user, setUser] = useState({});
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user") || "{}"));
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const greeting = () => {
    const h = time.getHours();
    return h < 12 ? "Good Morning" : h < 17 ? "Good Afternoon" : "Good Evening";
  };

  const fmt = (d) => d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  const fmtDate = (d) => d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

  return (
    <>
      <style>{`
        @keyframes wc-up    { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
        @keyframes wc-float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-4px)} }

        .wc-card {
          position:relative; overflow:hidden; border-radius:12px;
          background:linear-gradient(135deg,#0B2E33 0%,#1a4a52 55%,#4F7C82 100%);
          padding:16px 24px;
          display:flex; align-items:center; justify-content:space-between; gap:16px;
          box-shadow:0 8px 24px rgba(11,46,51,.25);
          min-height:80px;
        }
        .wc-card::before {
          content:''; position:absolute; left:0; top:0; bottom:0; width:4px;
          background:linear-gradient(180deg,#B8E3E9,#4F7C82);
          border-radius:12px 0 0 12px;
        }
        .wc-c1 {
          position:absolute; border-radius:50%; pointer-events:none;
          width:180px; height:180px; top:-50px; right:-30px;
          background:radial-gradient(circle,rgba(184,227,233,.08) 0%,transparent 70%);
        }
        .wc-left { position:relative; z-index:1; animation:wc-up .6s ease both; }
        .wc-greeting {
          font-size:9px; font-weight:700; letter-spacing:1.5px;
          text-transform:uppercase; color:#B8E3E9; margin-bottom:2px;
        }
        .wc-name  { font-size:18px; font-weight:800; color:#fff; line-height:1.2; }
        .wc-right { position:relative; z-index:1; text-align:right; flex-shrink:0; animation:wc-up .75s ease .1s both; display: flex; align-items: center; gap: 15px; }
        .wc-gem {
          width:36px; height:36px; border-radius:10px;
          background:rgba(184,227,233,.12); border:1px solid rgba(184,227,233,.15);
          display:flex; align-items:center; justify-content:center;
          font-size:16px;
          animation:wc-float 3s ease-in-out infinite;
        }
        .wc-time-wrap { display: flex; flex-direction: column; align-items: flex-end; }
        .wc-time {
          font-size:16px; font-weight:800; color:#fff; letter-spacing:0.5px;
          display:flex; align-items:center; gap:5px;
        }
        .wc-date { font-size:10px; color:rgba(184,227,233,.5); margin-top:1px; }

        @media(max-width:640px){
          .wc-card  { padding:12px 16px; }
          .wc-name  { font-size:16px; }
        }
      `}</style>

      <div className="wc-card">
        <div className="wc-c1"/>
        <div className="wc-left">
          <p className="wc-greeting">{greeting()} 👋</p>
          <h2 className="wc-name">{user?.Name || "Administrator"}</h2>
        </div>
        <div className="wc-right">
          <div className="wc-time-wrap">
            <div className="wc-time">
              <FaRegClock style={{ color:"rgba(184,227,233,.85)", fontSize:12 }}/>
              {fmt(time)}
            </div>
            <div className="wc-date">{fmtDate(time)}</div>
          </div>
          <div className="wc-gem"><FaGem style={{ color:"#B8E3E9" }} /></div>
        </div>
      </div>
    </>
  );
};

export default WelcomeCard;
